import { render, staticRenderFns } from "./ActivationsPopup.component.vue?vue&type=template&id=7151543e"
import script from "./ActivationsPopup.component.vue?vue&type=script&lang=js"
export * from "./ActivationsPopup.component.vue?vue&type=script&lang=js"
import style0 from "./ActivationsPopup.component.vue?vue&type=style&index=0&id=7151543e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports